import React from "react"
import styled from "styled-components"

export default styled(({ siteTitle, className }) => (
  <footer className={className}>
    © {new Date().getFullYear()} {siteTitle}
  </footer>
))`
  background-color: ${({ theme }) => theme.red};
  text-align: center;
  color: white;
  font-family: ${({ theme }) => theme.body};
  font-size: 0.875rem;
  padding: 0.875rem;
`
